import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/privacy/page.tsx");
